import React from 'react';
import { IconText } from '@reservamos/elements';
import { useTranslation } from 'react-i18next';
import useWhitelabelEnvs from '../../hooks/whitelabel/useWhitelabelEnvs';
import card from '../../images/payment/mercado-pago/card.png';
import store from '../../images/payment/mercado-pago/store.png';
import cash from '../../images/payment/mercado-pago/cash.png';
import phone from '../../images/payment/mercado-pago/phone.png';
import './PaymentBenefits';

/**
 * MercadoPagoIcons component.
 * Render the grid of MercadoPago payment benefit icons and copy.
 */
const MercadoPagoIcons = () => {
  const { t } = useTranslation('payment');
  const { brand } = useWhitelabelEnvs();
  // TODO: temporary brand-based conditional; this component will be refactored
  // to avoid hardcoding per-brand logic here. No whitelabel feature flag exists
  // yet for "show cash/wallet-balance benefits", so this checks brand directly.
  const showCashAndBalanceBenefits = brand !== 'cds';
  const benefits = [
    {
      img: card,
      text: t('mercadopago_benefits.first', { context: brand }),
    },
    {
      img: store,
      text: t('mercadopago_benefits.second'),
    },
    showCashAndBalanceBenefits && {
      img: cash,
      text: t('mercadopago_benefits.third'),
    },
    showCashAndBalanceBenefits && {
      img: phone,
      text: t('mercadopago_benefits.fourth'),
    },
  ].filter(Boolean);

  return (
    <div className="payment-benefits-grid">
      {benefits.map((data) => (
        <IconText key={data.img} iconSize="L" label={data.text} iconType={data.img} fontSize="S" />
      ))}
    </div>
  );
};

export default MercadoPagoIcons;
